export function Brand({ surface }: { surface?: string }) {
  return (
    <a className="brand" href="#top" aria-label="Amoye home">
      <span className="brand__name">Amoye</span>
      {surface && <span className="brand__surface">{surface}</span>}
    </a>
  );
}
